import { Button } from "@/components/core/button";

export default function StartTriggerButton() {
    return (
        <>
            <Button
                label="Let's Work"
                href="/start"
                size="sm"
                className="start-trigger"
            />
        </>
    );
}